import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { changeOrder } from '../../actionCreators';
const mapStateToProps = (state, { commentableItemId, commentableTypeId, parentId })=>{
    const { streamId, order } = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return {
        streamId,
        order
    };
};
const mapDispatchToProps = {
    onOrderChanged: changeOrder
};
export default connect(mapStateToProps, mapDispatchToProps);
